import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const therapies = [
  {
    title: "EMDR",
    subtitle: "Eye Movement Desensitization and Reprocessing",
    short:
      "Travmatik yaşantıların işlenmesinde kullanılan bilimsel temelli bir psikoterapi yöntemidir.",
  },
  {
    title: "Şema Terapi",
    subtitle: "Schema Therapy",
    short:
      "Erken yaşam deneyimlerinin bireyin düşünce ve ilişki kalıpları üzerindeki etkisini ele alan bütüncül bir terapi yaklaşımıdır.",
  },
  {
    title: "Somatik Terapi",
    subtitle: "Somatic Therapy",
    short:
      "Psikolojik süreçler ile bedensel deneyimler arasındaki ilişkiye odaklanan bir terapi yaklaşımıdır.",
  },
  {
    title: "Theraplay",
    subtitle: "",
    short:
      "Çocuk ve ebeveyn arasındaki ilişkiyi güçlendirmeyi amaçlayan etkileşim temelli bir terapi yaklaşımıdır.",
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

const cardVariant = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45 },
  },
};

export default function TerapiYaklasimlari() {
  return (
    <section className="border-t border-b border-gray-200 bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="mb-10 text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gray-500">
            Çalışma Alanları
          </p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            Kullandığım Psikoterapi Yaklaşımları
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600">
            Her danışanın ihtiyacına uygun olarak, bilimsel temelli ve etik ilkelere dayanan bir psikoterapi süreci planlanır.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.15 }}
          className="grid gap-5 md:grid-cols-1 xl:grid-cols-1"
        >
          {therapies.map((therapy) => (
            <motion.div
              key={therapy.title}
              variants={cardVariant}
              whileHover={{ y: -3 }}
              className="rounded-3xl border border-gray-200 bg-gray-50 p-6 shadow-sm transition hover:shadow-md"
            >
              <h3 className="text-xl font-semibold text-gray-900">
                {therapy.title}
              </h3>

              {therapy.subtitle && (
                <p className="mt-1 text-sm italic text-gray-500">
                  ({therapy.subtitle})
                </p>
              )}

              <p className="mt-4 text-sm leading-7 text-gray-600">
                {therapy.short}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.45, delay: 0.15 }}
          className="mt-10 flex justify-center"
        >
          <Link
            to="/calisma-alanlari"
            className="inline-flex items-center rounded-xl border border-gray-300 px-6 py-3 text-sm font-semibold text-gray-900 transition hover:bg-gray-50"
          >
            Tüm Yaklaşımları Gör →
          </Link>
        </motion.div>
      </div>
    </section>
  );
}